import ProductEmptyState from '../../../componentsv2/ProductEmptyState';
import { useLazyTranslation } from '../../../hooks/i18n';
import { filesURL } from '../../../constants/auth';

const BENEFITS = ['payments', 'fx', 'fdic'];

const STEPS = ['application', 'verify', 'operate'];

type GlobalAccountEmptyStateProps = {
  canRequest: boolean;
  hasBankingRequest: boolean;
  isSubmitting: boolean;
  onOpenAccount: () => void;
  onDiscoverMore: () => void;
};

const GlobalAccountEmptyState = ({
  canRequest,
  hasBankingRequest,
  isSubmitting,
  onOpenAccount,
  onDiscoverMore,
}: GlobalAccountEmptyStateProps) => {
  const { t } = useLazyTranslation(['banking-page', 'common']);

  return (
    <ProductEmptyState
      title={t('banking-page:globalAccount')}
      chip={hasBankingRequest ? t('banking-page:emptyState.inProgress.chip') : undefined}
      subtitle={
        hasBankingRequest
          ? t('banking-page:emptyState.inProgress.subtitle')
          : t('banking-page:emptyState.subtitle')
      }
      benefits={BENEFITS.map((key) => t(`banking-page:emptyState.benefits.${key}`))}
      cta={
        canRequest && !hasBankingRequest
          ? { label: t('banking-page:emptyState.cta'), onClick: onOpenAccount, isLoading: isSubmitting }
          : undefined
      }
      stepsTitle={t('banking-page:howDoesItWork.title')}
      steps={STEPS.map((key) => ({
        title: t(`banking-page:emptyState.steps.${key}.title`),
        description: t(`banking-page:emptyState.steps.${key}.description`),
      }))}
      discoverMoreLabel={t('common:productEmptyState.discoverMore')}
      onDiscoverMore={onDiscoverMore}
      heroSrc={`${filesURL}/${t('banking-page:emptyState.heroImage')}`}
    />
  );
};

export default GlobalAccountEmptyState;
